/**
 * WordPress dependencies
 */
import { createReduxStore, register } from '@wordpress/data';
/**
 * Internal dependencies
 */

import reducer from './reducer';
import * as actions from './actions';
import * as selectors from './selectors';
import { STORE_NAME } from './constants';
/**
 * Store definition for the meida source namespace.
 *
 * @see https://github.com/WordPress/gutenberg/blob/HEAD/packages/data/README.md#createReduxStore
 *
 * @type {Object}
 */

export const store = createReduxStore(STORE_NAME, {
  reducer,
  actions,
  selectors
});
register(store);
//# sourceMappingURL=index.js.map